/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AssignUserToCompanyCommandResult } from '../models/assign-user-to-company-command-result';
import { assignUserToCompanyPatch } from '../fn/company/assign-user-to-company-patch';
import { AssignUserToCompanyPatch$Params } from '../fn/company/assign-user-to-company-patch';
import { assignUserToCompanyPatch$Plain } from '../fn/company/assign-user-to-company-patch-plain';
import { AssignUserToCompanyPatch$Plain$Params } from '../fn/company/assign-user-to-company-patch-plain';
import { CreateCompanyCommandResult } from '../models/create-company-command-result';
import { createCompanyPost } from '../fn/company/create-company-post';
import { CreateCompanyPost$Params } from '../fn/company/create-company-post';
import { createCompanyPost$Plain } from '../fn/company/create-company-post-plain';
import { CreateCompanyPost$Plain$Params } from '../fn/company/create-company-post-plain';
import { DeleteCompanyCommandResult } from '../models/delete-company-command-result';
import { deleteCompanyDelete } from '../fn/company/delete-company-delete';
import { DeleteCompanyDelete$Params } from '../fn/company/delete-company-delete';
import { deleteCompanyDelete$Plain } from '../fn/company/delete-company-delete-plain';
import { DeleteCompanyDelete$Plain$Params } from '../fn/company/delete-company-delete-plain';
import { getCompaniesPost } from '../fn/company/get-companies-post';
import { GetCompaniesPost$Params } from '../fn/company/get-companies-post';
import { getCompaniesPost$Plain } from '../fn/company/get-companies-post-plain';
import { GetCompaniesPost$Plain$Params } from '../fn/company/get-companies-post-plain';
import { GetCompaniesQueriesResult } from '../models/get-companies-queries-result';
import { getCompanyGet } from '../fn/company/get-company-get';
import { GetCompanyGet$Params } from '../fn/company/get-company-get';
import { getCompanyGet$Plain } from '../fn/company/get-company-get-plain';
import { GetCompanyGet$Plain$Params } from '../fn/company/get-company-get-plain';
import { GetCompanyQueryResult } from '../models/get-company-query-result';
import { getCompanyUsersPost } from '../fn/company/get-company-users-post';
import { GetCompanyUsersPost$Params } from '../fn/company/get-company-users-post';
import { getCompanyUsersPost$Plain } from '../fn/company/get-company-users-post-plain';
import { GetCompanyUsersPost$Plain$Params } from '../fn/company/get-company-users-post-plain';
import { GetCompanyUsersQueryResult } from '../models/get-company-users-query-result';
import { RemoveUserFromCompanyCommandResult } from '../models/remove-user-from-company-command-result';
import { removeUserFromCompanyDelete } from '../fn/company/remove-user-from-company-delete';
import { RemoveUserFromCompanyDelete$Params } from '../fn/company/remove-user-from-company-delete';
import { removeUserFromCompanyDelete$Plain } from '../fn/company/remove-user-from-company-delete-plain';
import { RemoveUserFromCompanyDelete$Plain$Params } from '../fn/company/remove-user-from-company-delete-plain';
import { UpdateCompanyCommandResult } from '../models/update-company-command-result';
import { updateCompanyPatch } from '../fn/company/update-company-patch';
import { UpdateCompanyPatch$Params } from '../fn/company/update-company-patch';
import { updateCompanyPatch$Plain } from '../fn/company/update-company-patch-plain';
import { UpdateCompanyPatch$Plain$Params } from '../fn/company/update-company-patch-plain';

@Injectable({ providedIn: 'root' })
export class CompanyService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCompaniesPost()` */
  static readonly GetCompaniesPostPath = '/GetCompanies';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompaniesPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getCompaniesPost$Plain$Response(params?: GetCompaniesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCompaniesQueriesResult>> {
    return getCompaniesPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompaniesPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getCompaniesPost$Plain(params?: GetCompaniesPost$Plain$Params, context?: HttpContext): Observable<GetCompaniesQueriesResult> {
    return this.getCompaniesPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetCompaniesQueriesResult>): GetCompaniesQueriesResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompaniesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getCompaniesPost$Response(params?: GetCompaniesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCompaniesQueriesResult>> {
    return getCompaniesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompaniesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getCompaniesPost(params?: GetCompaniesPost$Params, context?: HttpContext): Observable<GetCompaniesQueriesResult> {
    return this.getCompaniesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetCompaniesQueriesResult>): GetCompaniesQueriesResult => r.body)
    );
  }

  /** Path part for operation `getCompanyUsersPost()` */
  static readonly GetCompanyUsersPostPath = '/GetCompanyUsers';

  /**
   * get all users of the company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyUsersPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getCompanyUsersPost$Plain$Response(params?: GetCompanyUsersPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCompanyUsersQueryResult>> {
    return getCompanyUsersPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * get all users of the company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyUsersPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getCompanyUsersPost$Plain(params?: GetCompanyUsersPost$Plain$Params, context?: HttpContext): Observable<GetCompanyUsersQueryResult> {
    return this.getCompanyUsersPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetCompanyUsersQueryResult>): GetCompanyUsersQueryResult => r.body)
    );
  }

  /**
   * get all users of the company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyUsersPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getCompanyUsersPost$Response(params?: GetCompanyUsersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCompanyUsersQueryResult>> {
    return getCompanyUsersPost(this.http, this.rootUrl, params, context);
  }

  /**
   * get all users of the company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyUsersPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getCompanyUsersPost(params?: GetCompanyUsersPost$Params, context?: HttpContext): Observable<GetCompanyUsersQueryResult> {
    return this.getCompanyUsersPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetCompanyUsersQueryResult>): GetCompanyUsersQueryResult => r.body)
    );
  }

  /** Path part for operation `getCompanyGet()` */
  static readonly GetCompanyGetPath = '/GetCompany';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyGet$Plain$Response(params?: GetCompanyGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCompanyQueryResult>> {
    return getCompanyGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyGet$Plain(params?: GetCompanyGet$Plain$Params, context?: HttpContext): Observable<GetCompanyQueryResult> {
    return this.getCompanyGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetCompanyQueryResult>): GetCompanyQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyGet$Response(params?: GetCompanyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCompanyQueryResult>> {
    return getCompanyGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyGet(params?: GetCompanyGet$Params, context?: HttpContext): Observable<GetCompanyQueryResult> {
    return this.getCompanyGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetCompanyQueryResult>): GetCompanyQueryResult => r.body)
    );
  }

  /** Path part for operation `createCompanyPost()` */
  static readonly CreateCompanyPostPath = '/CreateCompany';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createCompanyPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createCompanyPost$Plain$Response(params?: CreateCompanyPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateCompanyCommandResult>> {
    return createCompanyPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createCompanyPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createCompanyPost$Plain(params?: CreateCompanyPost$Plain$Params, context?: HttpContext): Observable<CreateCompanyCommandResult> {
    return this.createCompanyPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateCompanyCommandResult>): CreateCompanyCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createCompanyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createCompanyPost$Response(params?: CreateCompanyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateCompanyCommandResult>> {
    return createCompanyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createCompanyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createCompanyPost(params?: CreateCompanyPost$Params, context?: HttpContext): Observable<CreateCompanyCommandResult> {
    return this.createCompanyPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateCompanyCommandResult>): CreateCompanyCommandResult => r.body)
    );
  }

  /** Path part for operation `assignUserToCompanyPatch()` */
  static readonly AssignUserToCompanyPatchPath = '/AssignUserToCompany';

  /**
   * Assign specific user to company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assignUserToCompanyPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  assignUserToCompanyPatch$Plain$Response(params?: AssignUserToCompanyPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AssignUserToCompanyCommandResult>> {
    return assignUserToCompanyPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Assign specific user to company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assignUserToCompanyPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  assignUserToCompanyPatch$Plain(params?: AssignUserToCompanyPatch$Plain$Params, context?: HttpContext): Observable<AssignUserToCompanyCommandResult> {
    return this.assignUserToCompanyPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AssignUserToCompanyCommandResult>): AssignUserToCompanyCommandResult => r.body)
    );
  }

  /**
   * Assign specific user to company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assignUserToCompanyPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  assignUserToCompanyPatch$Response(params?: AssignUserToCompanyPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<AssignUserToCompanyCommandResult>> {
    return assignUserToCompanyPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Assign specific user to company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assignUserToCompanyPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  assignUserToCompanyPatch(params?: AssignUserToCompanyPatch$Params, context?: HttpContext): Observable<AssignUserToCompanyCommandResult> {
    return this.assignUserToCompanyPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<AssignUserToCompanyCommandResult>): AssignUserToCompanyCommandResult => r.body)
    );
  }

  /** Path part for operation `updateCompanyPatch()` */
  static readonly UpdateCompanyPatchPath = '/UpdateCompany';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCompanyPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateCompanyPatch$Plain$Response(params?: UpdateCompanyPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateCompanyCommandResult>> {
    return updateCompanyPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCompanyPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateCompanyPatch$Plain(params?: UpdateCompanyPatch$Plain$Params, context?: HttpContext): Observable<UpdateCompanyCommandResult> {
    return this.updateCompanyPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateCompanyCommandResult>): UpdateCompanyCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCompanyPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateCompanyPatch$Response(params?: UpdateCompanyPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateCompanyCommandResult>> {
    return updateCompanyPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCompanyPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateCompanyPatch(params?: UpdateCompanyPatch$Params, context?: HttpContext): Observable<UpdateCompanyCommandResult> {
    return this.updateCompanyPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateCompanyCommandResult>): UpdateCompanyCommandResult => r.body)
    );
  }

  /** Path part for operation `deleteCompanyDelete()` */
  static readonly DeleteCompanyDeletePath = '/DeleteCompany';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteCompanyDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteCompanyDelete$Plain$Response(params?: DeleteCompanyDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteCompanyCommandResult>> {
    return deleteCompanyDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteCompanyDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteCompanyDelete$Plain(params?: DeleteCompanyDelete$Plain$Params, context?: HttpContext): Observable<DeleteCompanyCommandResult> {
    return this.deleteCompanyDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteCompanyCommandResult>): DeleteCompanyCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteCompanyDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteCompanyDelete$Response(params?: DeleteCompanyDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteCompanyCommandResult>> {
    return deleteCompanyDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteCompanyDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteCompanyDelete(params?: DeleteCompanyDelete$Params, context?: HttpContext): Observable<DeleteCompanyCommandResult> {
    return this.deleteCompanyDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteCompanyCommandResult>): DeleteCompanyCommandResult => r.body)
    );
  }

  /** Path part for operation `removeUserFromCompanyDelete()` */
  static readonly RemoveUserFromCompanyDeletePath = '/RemoveUserFromCompany';

  /**
   * Remove specific user from company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeUserFromCompanyDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  removeUserFromCompanyDelete$Plain$Response(params?: RemoveUserFromCompanyDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<RemoveUserFromCompanyCommandResult>> {
    return removeUserFromCompanyDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove specific user from company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeUserFromCompanyDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  removeUserFromCompanyDelete$Plain(params?: RemoveUserFromCompanyDelete$Plain$Params, context?: HttpContext): Observable<RemoveUserFromCompanyCommandResult> {
    return this.removeUserFromCompanyDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<RemoveUserFromCompanyCommandResult>): RemoveUserFromCompanyCommandResult => r.body)
    );
  }

  /**
   * Remove specific user from company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeUserFromCompanyDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  removeUserFromCompanyDelete$Response(params?: RemoveUserFromCompanyDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<RemoveUserFromCompanyCommandResult>> {
    return removeUserFromCompanyDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove specific user from company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeUserFromCompanyDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  removeUserFromCompanyDelete(params?: RemoveUserFromCompanyDelete$Params, context?: HttpContext): Observable<RemoveUserFromCompanyCommandResult> {
    return this.removeUserFromCompanyDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<RemoveUserFromCompanyCommandResult>): RemoveUserFromCompanyCommandResult => r.body)
    );
  }

}
